import React from 'react';
import {
  Input,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import { InputProps } from '@material-ui/core/Input';

import { InputLabelProps } from '@material-ui/core/InputLabel';
import { InputBaseComponentProps } from '@material-ui/core/InputBase';
import { ClassApi } from '../../types/styles';
import Tooltip from '../tooltip/Tooltip';
import useStyles from './styles';

type Props = Omit<InputProps, 'classes'> & {
  label?: string;
  tooltip?: string;
  value: string;
  classes?: ClassApi<typeof useStyles>;
  inputLabelProps?: Omit<InputLabelProps, 'classes'>;
};

const defaultInputProps: Partial<InputBaseComponentProps> = {
  spellCheck: false,
};

const FormInput = ({
  label,
  tooltip = '',
  className,
  endAdornment,
  classes: externalClasses = {},
  inputLabelProps: labelProps = {},
  inputProps = {},
  ...muiInputProps
}: Props) => {
  const classes = useStyles({ classes: externalClasses });

  return (
    <FormControl
      fullWidth
      disabled
      className={className}
      classes={{
        root: classes.root,
      }}
    >
      {label && (
        <Tooltip title={tooltip}>
          <InputLabel
            classes={{
              root: classes.labelRoot,
              focused: classes.focused,
            }}
            {...labelProps}
          >
            {label}
          </InputLabel>
        </Tooltip>
      )}
      <Input
        disabled
        endAdornment={endAdornment}
        {...muiInputProps}
        inputProps={{
          ...defaultInputProps,
          ...inputProps,
        }}
        classes={{
          input: classes.input,
          underline: classes.inputUnderline,
          focused: classes.focused,
          disabled: classes.disabled,
        }}
      />
    </FormControl>
  );
};

export default FormInput;
